const useAnalytics = () => {
    const isProduction = window.location.href.startsWith("https://app.pathway-solutions.de/");

    const newUserSourceCookie = document.cookie.match(/source=([^;]+)/)?.[1] || "";
    const facebookClickIdCookie = document.cookie.match(/_fbp=([^;]+)/)?.[1] || "";
    const googleClickIdCookie = document.cookie.match(/_gcl_aw=([^;]+)/)?.[1] || "";

    return {
        isProduction,
        analytics: {
            newUserSource: newUserSourceCookie,
            facebookClickId: facebookClickIdCookie,
            googleClickId: googleClickIdCookie,
        },
    };
};

export default useAnalytics;
